import * as React from "react"
import * as ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { history, store, persistor } from "./redux/store"
import { PersistGate } from "redux-persist/integration/react"
import Loader from "./components/utility/loader"
import MainRouter from "./router"

import "../node_modules/jquery/dist/jquery.min.js"
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js"
import "./index.css"

import "lazysizes"
// import a plugin
import "lazysizes/plugins/parent-fit/ls.parent-fit"

import registerServiceWorker from "./registerServiceWorker"

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <MainRouter history={history} />
    </PersistGate>
  </Provider>,

  document.getElementById("root") as HTMLElement
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx